export default class IFrameScope {
  constructor({ container, source, prefix }) {
    this.container = container;
    this.source = source;
    this.prefix = prefix;

    this.state = {
      ready: false,
    }
    this.callbacks = {
      onReady: [],
    }

    this.steps = []; // DEBUG
    this.scriptLoaded = false;

    this.init();
  }

  init = () => {
    this.steps.push(1)
    this.iframe = document.createElement('iframe');
    this.iframe.setAttribute('allowfullscreen', '');
    this.iframe.setAttribute('mozallowfullscreen', '');
    this.iframe.setAttribute('webkitallowfullscreen', '');
    this.iframe.setAttribute('frameborder', '0');
    this.iframe.setAttribute('allow', 'autoplay');
    this.iframe.setAttribute('sandbox', 'allow-forms allow-same-origin allow-pointer-lock allow-popups allow-top-navigation allow-scripts');
    this.iframe.id = 'vads-scope'
    this.iframe.className = 'vads-slot';
    // this.iframe.style.cssText = 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: -1; overflow: hidden;';

    this.steps.push(2)
    this.iframe.onload = () => {
      const onError = (e) => {
        this.steps.push(6, String(e))
        console.log(`[${this.prefix}] lib error`, e);

        this.iframe.contentDocument.querySelector(`script[src="${this.source}"]`).remove();
        setTimeout(() => this.iframe.contentDocument.body.appendChild(this.createScript(onError)), 2500);
      }
      this.steps.push(3)
      const styles = document.createElement('style');
      // this.iframe.contentWindow.document.write('<body></body>');
      styles.innerHTML = `* { margin: 0; padding: 0; overflow: hidden; } video { max-width: 100%; height: auto; } .vads-scope-slot { position: absolute; left: 0; top: 0; width: 100%; height: 100%; display: flex; align-items: center; }`;

      this.steps.push(4)
      const script = this.createScript(onError);
      // const script = document.createElement('script');
      // script.src = this.source;
      // script.async = true;
      // script.onload = () => {
      //   this.steps.push(5)
      //   this.state.ready = true;
      //   this.callbacks.onReady.forEach(callback => callback())
      // }
      // script.onerror = onError

      this.steps.push(7)
      this.iframe.contentDocument.body.append(styles, script); //this.slot
    }

    this.steps.push(8)
    this.iframe.onerror = (e) => { this.steps.push(9); console.error(`[${this.prefix}] iframe error`, e); }
    this.iframe.setAttribute("prefix", this.prefix);
    this.container.appendChild(this.iframe);
  }

  createScript = (onError) => {
    const script = document.createElement('script');
    script.src = this.source;
    script.async = true;
    script.onload = () => {
      this.steps.push(5)
      this.scriptLoaded = true;
      this.state.ready = true;
      this.callbacks.onReady.forEach(callback => callback())
    }
    script.onerror = onError

    return script;
  }

  getIFrame = () => this.iframe;

  subscribe = (callback) => {
    this.callbacks.onReady.push(callback);
  }

  addSlot = (id) => {
    const slot = this.iframe.contentDocument.createElement('div');
    slot.id = id;
    slot.className = 'vads-scope-slot';
    this.iframe.contentDocument.body.appendChild(slot);
  }

  removeSlot = (id) => {
    if (!this.iframe.contentDocument) return;

    const slot = this.iframe.contentDocument.body.querySelector(`#${id}`);
    if (slot) slot.remove();
  }

  get ready() { return this.state.ready; }
}
